import { highnoteClient } from "@highnoteplatform/internal-sdk";
import {
  sdkIdentityFromPackage,
  type HighnoteEnvironment,
} from "@highnoteplatform/types";

import { name, version } from "../package.json";

const SDK = sdkIdentityFromPackage({ name, version });

// environment is OPTIONAL to match DocumentUploadSdkConfig.environment
// (packages/types/src/documentUploadSdk.ts) — a required param would fail
// typecheck at all four call sites.
export const documentUploadClient = (config: {
  clientToken: string;
  environment?: HighnoteEnvironment;
}) => highnoteClient(config.clientToken, config.environment, SDK);
